<template>

  <div class="mt3 w-100 w-auto-ns">

    <div class="flex flex-row justify-center">

      <a class="flex flex-row items-center justify-center w-50 f6 glow hover-bg-blue hover-white link ba ph3 pv2 mb2 dib blue pointer br2"
        :hymnalName="hymnals.name" @click="$router.go(-1)">

        <i class="f4 fas fa-caret-left pr2"></i>
        New Search
        <!-- <span class="ph2">New Search</span> -->

      </a>

    </div>

    <core-hymnal-header :hymnalName="hymnal" />

    <div v-if="hymn && hymn.choir && hymnal === 'tccog2010'" class="flex justify-center mt3">

      <div class="flex flex-row items-center mv2 ph2 ba br1 b--moon-gray">

        <i class="fas fa-users mh1 mv1 f7 blue"></i>

        <span class="f6 gray">
          This hymn music includes choir accompaniment
        </span>

      </div>

    </div>

    <div class="flex flex-column tl fw3 main-container ph3 ph0-ns mt3">

      <div class="flex flex-row items-center justify-start">

        <div v-if="hymn" class="mr3 white f3">

          <div v-if="hymn.approved === true" class="fw7 bg-green h3 w3 br2 tc pv3">
            {{ page }}
          </div>

          <div v-if="hymn.approved === false" class="fw7 bg-light-red h3 w3 br2 tc pv3">
            {{ page }}
          </div>

          <div v-if="hymn.approved === null" class="fw7 bg-moon-gray h3 w3 br2 tc pv3">
            {{ page }}
          </div>

        </div>

        <div v-if="hymn" class="flex flex-column">

          <div class="fw5">{{ hymn.title }}</div>

          <div>{{ hymn.author }}</div>

        </div>

      </div>

      <div v-if="hymn" class="f5">

        <p>{{ hymn.authorInfo }}</p>

      </div>

      <div v-if="hymn && hymn.references">

        <a :href="hymn.references" target="_blank">Source</a>

      </div>

      <div v-if="hymn" class="flex flex-row items-center justify-center flex-wrap pt3">

        <div v-if="hymn.wcg1974 && hymnal !== 'wcg1974'"
          class="flex flex-column justify-center items-center ba br1 b--moon-gray mr1 mb1">

          <div class="f7 gray ph1">WCG 1974</div>

          <div class="bg-moon-gray white fw7 bt b--moon-gray b1 w-100 tc">
            {{ hymn.wcg1974 }}
          </div>

        </div>

        <div v-if="hymn.wcg1993 && hymnal !== 'wcg1993'"
          class="flex flex-column justify-center items-center ba br1 b--moon-gray mr1 mb1">

          <div class="f7 gray ph1">WCG 1993</div>

          <div class="bg-moon-gray white fw7 bt b--moon-gray b1 w-100 tc">
            {{ hymn.wcg1993 }}
          </div>

        </div>

        <div v-if="hymn.ucg1997 && hymnal !== 'ucg1997'"
          class="flex flex-column justify-center items-center ba br1 b--moon-gray mr1 mb1">

          <div class="f7 gray ph1">UCG 1997</div>

          <div class="bg-moon-gray white fw7 bt b--moon-gray b1 w-100 tc">
            {{ hymn.ucg1997 }}
          </div>

        </div>

        <div v-if="hymn.ucg2007 && hymnal !== 'ucg2007'"
          class="flex flex-column justify-center items-center ba br1 b--moon-gray mr1 mb1">

          <div class="f7 gray ph1">UCG 2007</div>

          <div class="bg-moon-gray white fw7 bt b--moon-gray b1 w-100 tc">
            {{ hymn.ucg2007 }}
          </div>

        </div>

        <div v-if="hymn.lcg2005 && hymnal !== 'lcg2005'"
          class="flex flex-column justify-center items-center ba br1 b--moon-gray mr1 mb1">

          <div class="f7 gray ph1">LCG 2005</div>

          <div class="bg-moon-gray white fw7 bt b--moon-gray b1 w-100 tc">
            {{ hymn.lcg2005 }}
          </div>

        </div>

        <div v-if="hymn.cogwa2011 && hymnal !== 'cogwa2011'"
          class="flex flex-column justify-center items-center ba br1 b--moon-gray mr1 mb1">

          <div class="f7 gray ph1">COGWA 2011</div>

          <div class="bg-moon-gray white fw7 bt b--moon-gray b1 w-100 tc">
            {{ hymn.cogwa2011 }}
          </div>

        </div>

        <div v-if="hymn.pacific2018 && hymnal !== 'pacific2018'"
          class="flex flex-column justify-center items-center ba br1 b--moon-gray mr1 mb1">

          <div class="f7 gray ph1">PacCG 2018</div>

          <div class="bg-moon-gray white fw7 bt b--moon-gray b1 w-100 tc">
            {{ hymn.pacific2018 }}
          </div>

        </div>

        <div v-if="hymn.tccog2010 && hymnal !== 'tccog2010'"
          class="flex flex-column justify-center items-center ba br1 b--moon-gray mr1 mb1">

          <div class="f7 gray ph1">TC 2010</div>

          <div class="bg-moon-gray white fw7 bt b--moon-gray b1 w-100 tc">
            {{ hymn.tccog2010 }}
          </div>

        </div>

      </div>

      <!-- Lyrics -->

      <div v-if="hymn && hymn.verse_1" class="flex flex-column mt4 pb5">

        <div class="flex flex-row items-center justify-between bb b--moon-gray pb1">

          <div><strong>Lyrics:</strong></div>

          <div class="flex flex-row items-center">

            <div @click="increaseFontSize"
              class="f6 glow bg-white hover-bg-light-blue hover-white link ba ph1  light-blue pointer br2">

              <i class="fas fa-plus"></i>

            </div>

            <i class="fas fa-text-height mh1 blue"></i>

            <div @click="decreaseFontSize"
              class="f6 glow bg-white hover-bg-light-blue hover-white link ba ph1  light-blue pointer br2">

              <i class="fas fa-minus"></i>

            </div>

          </div>

        </div>

        <div v-if="hymn" :style="{ fontSize: fontSize + 'px' }">

          <div v-if="hymn.verse_1" class="pv2">{{ hymn.verse_1 }}</div>

          <div v-if="hymn.verse_2" class="pv2 bt b--moon-gray">
            {{ hymn.verse_2 }}
          </div>

          <div v-if="hymn.verse_3" class="pv2 bt b--moon-gray">
            {{ hymn.verse_3 }}
          </div>

          <div v-if="hymn.verse_4" class="pv2 bt b--moon-gray">
            {{ hymn.verse_4 }}
          </div>

          <div v-if="hymn.verse_5" class="pv2 bt b--moon-gray">
            {{ hymn.verse_5 }}
          </div>

          <div v-if="hymn.verse_6" class="pv2 bt b--moon-gray">
            {{ hymn.verse_6 }}
          </div>

          <div v-if="hymn.verse_7" class="pv2 bt b--moon-gray">
            {{ hymn.verse_7 }}
          </div>

          <div v-if="hymn.verse_8" class="pv2 bt b--moon-gray">
            {{ hymn.verse_8 }}
          </div>

          <div v-if="hymn.verse_9" class="pv2 bt b--moon-gray">
            {{ hymn.verse_9 }}
          </div>

          <div v-if="hymn.verse_10" class="pv2 bt b--moon-gray">
            {{ hymn.verse_10 }}
          </div>

          <div v-if="hymn.verse_11" class="pv2 bt b--moon-gray">
            {{ hymn.verse_11 }}
          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import hymnsData from '@/assets/hymnals.json'

const props = defineProps({
  page: {
    type: Number,
    required: true
  },
  hymnal: {
    type: String,
    required: true
  }
})

const store = useStore()
const router = useRouter()

const hymn = ref(null)
const hymns = ref([])

const hymnals = computed(() => store.getters['hymnals/hymnals'])
const fontSize = computed(() => store.getters['hymnals/fontSize'])

const getFilteredHymns = (hymnsList, hymnalUrl) => {
  return hymnsList
    .filter(hymn => hymn[hymnalUrl])
    .sort((a, b) => a[hymnalUrl] - b[hymnalUrl])
}

const getHymn = (page) => {
  const foundHymn = hymns.value.find(h => h[props.hymnal] === page)
  if (foundHymn) {
    hymn.value = foundHymn
  } else {
    router.push({
      name: 'error',
      params: {
        hymnal: props.hymnal
      }
    })
  }
}

const increaseFontSize = () => {
  if (fontSize.value < 30) {
    store.commit('hymnals/INCREASE_FONT_SIZE')
  }
}

const decreaseFontSize = () => {
  if (fontSize.value > 10) {
    store.commit('hymnals/DECREASE_FONT_SIZE')
  }
}

onMounted(() => {
  hymns.value = getFilteredHymns(hymnsData, props.hymnal)
  getHymn(props.page)
})
</script>

<style scoped></style>
